import history from 'app/history'
import { Translate } from 'react-redux-i18n'

const handleBack = (to, e) => {
  e.preventDefault();
  // fallback to a local path if the refferer path is outside the app
  if(history.initLength === history.length) {
    history.replace(to);
  } else {
    history.goBack();
  }
};

export default ({ to, label, className }) => (
  <a href="#" onClick={handleBack.bind(null, to)} className={className}>
    {label ? <Translate value={label} /> : null}
  </a>
);

